import { useState } from "react";
import { useTranslation } from "react-i18next";
import type {
  CodeSentResponse,
  TokenResponse,
} from "@/shared/api/generated/iSHONCHPlatformAPI.schemas";
import { session } from "@/shared/api/session";
import { CodeStep } from "./CodeStep";
import { PhoneStep } from "./PhoneStep";
import { linkTelegramAfterLogin } from "../model/telegramSession";

type Step = { name: "phone" } | { name: "code"; phone: string; sent: CodeSentResponse };

/**
 * Login by phone number and one-time SMS code, with two hosts (D31): the /login page (redirects, deep links) and
 * the login sheet that opens over the current page in the middle of an action. Signs the session in and calls
 * `onSignedIn`.
 */
export function LoginForm({
  onSignedIn,
  heading,
}: {
  onSignedIn: (tokens: TokenResponse) => void;
  /** The page shows the step title as its h1; the sheet has its own title. */
  heading?: "h1" | "h2";
}) {
  const { t } = useTranslation("auth");
  const [step, setStep] = useState<Step>({ name: "phone" });
  const [lastPhone, setLastPhone] = useState("");
  const Heading = heading;

  return (
    <div className="flex flex-col gap-6">
      {Heading && (
        <Heading className="text-title-lg font-semibold text-ink-strong">
          {step.name === "phone" ? t("title") : t("codeTitle")}
        </Heading>
      )}
      {step.name === "phone" ? (
        <PhoneStep
          defaultPhone={lastPhone}
          onCodeSent={(phone, sent) => {
            setLastPhone(phone.replace("+998", ""));
            setStep({ name: "code", phone, sent });
          }}
        />
      ) : (
        <CodeStep
          phone={step.phone}
          sent={step.sent}
          onResent={(sent) => {
            setStep({ ...step, sent });
          }}
          onChangePhone={() => {
            setStep({ name: "phone" });
          }}
          onVerified={(tokens) => {
            session.signIn(tokens.as_access_token, tokens.as_account_id);
            linkTelegramAfterLogin();
            onSignedIn(tokens);
          }}
        />
      )}
    </div>
  );
}
